import { render, staticRenderFns } from "./RadialMenu.vue?vue&type=template&id=4cf9dd4e&scoped=true&"
import script from "./RadialMenu.js?vue&type=script&lang=js&"
export * from "./RadialMenu.js?vue&type=script&lang=js&"
import style0 from "./RadialMenu.css?vue&type=style&index=0&id=4cf9dd4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf9dd4e",
  null
  
)

export default component.exports